import React, {useRef, useContext, FC} from "react";
import { toast, ToastOptions, UpdateOptions } from "react-toastify";

export enum toastType {
    Info = "info",
    Success = "success",
    Warning = "warning",
    Error = "error"
}

interface IToastContext {
    popToast: (type: toastType, message: string, id?: undefined | string | number) => void,
}

const defaultToastContext = {
    popToast: (type: toastType, message: string, id?: undefined | string | number) => {return;}
}

interface IToastProvider {
    children?: React.ReactNode,
}


const ToastContext = React.createContext<IToastContext>(defaultToastContext);
export const UseToastContext = () => useContext(ToastContext);


export const ToastContextProvider:FC<IToastProvider> = ({children}) => {
    
    const getToastConfig = (type: toastType, existingConfig?: ToastOptions|undefined): ToastOptions => {
        if (existingConfig == undefined) existingConfig = {};
        existingConfig.type ??= type;
        existingConfig.theme ??= "light";
        existingConfig.autoClose ??= 5000;
        existingConfig.hideProgressBar ??= true;
        existingConfig.closeOnClick ??= true;
        existingConfig.position ??= type == toastType.Error ? "bottom-center" : "bottom-left";
        existingConfig.className ??= "toastFullWidth";
        existingConfig.icon ??= <img></img>;
        //existingConfig.closeButton ??= <img></img>;
        return existingConfig;
    }

    const popToast = (type: toastType, message: string, id?: undefined | string | number) => {
        // Force ID in case of error to only have one single toast for errors
        if (type == toastType.Error) id = "toastErrorUnique";
        if (id != undefined && toast.isActive(id)) {
            let config = getToastConfig(type) as UpdateOptions;
            config.render = message;
            toast.update(id, config);
        } else {
            toast(message, getToastConfig(type, {toastId: id}));
        }
    }

    return(
        <ToastContext.Provider value={{popToast}}>{children}</ToastContext.Provider>
    )
}